/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { Reader, ReaderInterface } from "../Reader";

const _abi = [
  {
    inputs: [],
    name: "BASIS_POINTS_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "POSITION_PROPS_LENGTH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDG_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVault",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
    ],
    name: "getAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVault",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountIn",
        type: "uint256",
      },
    ],
    name: "getFeeBasisPoints",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getFees",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_usdgAmount",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getFullVaultTokenInfo",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getFundingRates",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVault",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
    ],
    name: "getMaxAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_factory",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getPairInfo",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_collateralTokens",
        type: "address[]",
      },
      {
        internalType: "address[]",
        name: "_indexTokens",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "_isLong",
        type: "bool[]",
      },
    ],
    name: "getPositions",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVaultPriceFeed",
        name: "_priceFeed",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getPrices",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_yieldTrackers",
        type: "address[]",
      },
    ],
    name: "getStakingInfo",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getTokenBalances",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getTokenBalancesWithSupplies",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_excludedAccounts",
        type: "address[]",
      },
    ],
    name: "getTokenSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_accounts",
        type: "address[]",
      },
    ],
    name: "getTotalBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_yieldTokens",
        type: "address[]",
      },
    ],
    name: "getTotalStaked",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_usdgAmount",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getVaultTokenInfo",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_usdgAmount",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "getVaultTokenInfoV2",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_vesters",
        type: "address[]",
      },
    ],
    name: "getVestingInfo",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gov",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "hasMaxGlobalShortSizes",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_hasMaxGlobalShortSizes",
        type: "bool",
      },
    ],
    name: "setConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ReaderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ReaderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Reader__factory extends ContractFactory {
  constructor(...args: ReaderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      Reader & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Reader__factory {
    return super.connect(runner) as Reader__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ReaderInterface {
    return new Interface(_abi) as ReaderInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Reader {
    return new Contract(address, _abi, runner) as unknown as Reader;
  }
}
